module.exports = __webpack_public_path__ + "img/智能比价.fda504ed.png";